import { Client } from '../../domain/ClientSlice/Client';
import { LoginRequest } from '../../domain/SecuritySlice/LoginRequest';
import { LoginResult } from '../../domain/SecuritySlice/LoginResult';
import { PasswordReset } from '../../domain/SecuritySlice/PasswordReset';
import { PasswordResetRequest } from '../../domain/SecuritySlice/PasswordResetRequest';
import { RegisterClient } from '../../domain/SecuritySlice/RegisterClient';
import ApiWrapper from '../Common/ApiWrapper';

export class AuthRepository 
    extends ApiWrapper {
    constructor() {
        super('authentication/');
    }

    async existsEmail(email: string): Promise<boolean | null> {
        return await this.getOneCustom({url: `email/exists`, params: {email}});
    }

    async existsUserName(userName: string): Promise<boolean | null> {
        return await this.getOneCustom({ url: `username/exists`, params: { userName }});
    }

    async login(request: LoginRequest): Promise<LoginResult | null> {
        return await this.postCustom({ url: `login`, data: request });
    }

    async register(request: RegisterClient): Promise<Client | null> {
        return await this.postCustom({ url: `register-client`, data: request });
    }

    async requestPasswordReset(request: PasswordResetRequest): Promise<boolean | null> {
        return await this.postCustom({ url: `request-password-reset`, data: request });
    }

    async passwordReset(request: PasswordReset): Promise<boolean | null> {
        return await this.postCustom({ url: `password-reset`, data: request });
    }
}
